//#region src/menu_section_price_display.ts
var MenuSectionPriceDisplay = /* @__PURE__ */ function(MenuSectionPriceDisplay) {
	MenuSectionPriceDisplay[MenuSectionPriceDisplay["Default"] = 1] = "Default";
	MenuSectionPriceDisplay[MenuSectionPriceDisplay["HidePriceOptions"] = 2] = "HidePriceOptions";
	return MenuSectionPriceDisplay;
}(MenuSectionPriceDisplay || {});
//#endregion
export { MenuSectionPriceDisplay };

//# sourceMappingURL=menu_section_price_display.js.map